<template>
    <LandingPage>
      <template slot="taption_header">
        <div id="text1-strings">
          <p>Transkribieren</p>
          <p>ChatGPT für</p>
          <p>Übersetzen</p>
          <p>Untertitel hinzufügen zu</p>
        </div>
        <span id="text1"></span>Ihrem Video.</template>
      <template slot="landing_description">Erstellen Sie automatisch Transkripte, Übersetzungen, Untertitel und analysieren Sie Ihre Videos in über 40 Sprachen.</template>

      <template slot="intro_video">
    
          <video playsinline class="intro-video" :src='"@/assets/video/landing_en.mp4"' autoplay frameborder="0" height="350" width="575" muted></video>
      </template>

      <template slot="start_your_trial">TAPTION AUSPROBIEREN</template>

      <template slot="use_case_title">Produktfunktionen.</template>
      <template slot="youtubers">Video in Text umwandeln</template>
      <template slot="youtubers_question">Transkribieren Sie Ihre Videos und generieren Sie automatisch Untertitel</template>


      <template slot="journalists">KI-Analyse</template>
      <template slot="journalists_question">Fassen Sie Videos zusammen, generieren Sie Themen und erstellen Sie YouTube-Kapitel. Nutzen Sie Ihren eigenen angepassten ChatGPT</template>
     
      <template slot="translators">Video übersetzen</template>
      <template slot="translators_question">Übersetzen Sie Ihre Untertitel und Transkripte in über 50 Sprachen</template>

      <template slot="speaker">Sprechererkennung</template>
      <template slot="speaker_question">Konvertieren Sie Audio in Text und kennzeichnen Sie Sprecher in Ihren Aufnahmen</template>

      <template slot="audiotomp4">Konvertieren Sie Ihre Audiodatei in ein Video</template>
      <template slot="audiotomp4_question">Verwenden Sie Ihre Audiodatei und ein Bild, um ein MP4-Video mit Untertiteln zu erstellen</template>

      <template slot="importsrt">TXT in SRT umwandeln</template>
      <template slot="importsrt_question">Fügen Sie Zeitstempel zu Text hinzu und formatieren Sie automatisch.</template>

      <template slot="share">Mit Teams zusammenarbeiten</template>
      <template slot="share_question">Teilen Sie Konten und passen Sie Funktionen mit Benutzerberechtigung-Management an</template>

      <template slot="learnmore">Mehr erfahren</template>
      

      <template slot="simple_workflow">Einfacher Arbeitsablauf.</template>
      <template slot="upload">Hochladen</template>
      <template slot="upload_description">Laden Sie Ihr Video auf unsere Plattform hoch oder nutzen Sie unseren YouTube-Transkript-Generator, um direkt von YouTube zu transkribieren. Sie können auch Dateien von Zoom, Webex und Google Drive hochladen.</template>
      <template slot="edit_translate">Bearbeiten</template>
      <template slot="edit_translate_description">Bearbeiten Sie Ihr Transkript, ohne sich um die Anpassung der Zeitstempel kümmern zu müssen. Zusätzlich ermöglicht unser Online-Video-Editor die direkte Bearbeitung Ihres Videos auf der Plattform.</template>
      <template slot="transcribe">KI-Analyse</template>
      <template slot="transcribe_description">Stellen Sie beliebige Fragen, um Videoinhalte abzufragen. Wir bieten gängige Vorlagen wie die Erstellung von Zeitstempel-basierten YouTube-Kapiteln, Videozusammenfassungen, YouTube-Zusammenfassungen und Video-Themengeneratoren.</template>
      <template slot="translate">Übersetzen</template>
      <template slot="translate_description">Unsere Online-Übersetzung unterstützt über 40 Sprachen und übertrifft besonders bei Übersetzungen zwischen überregionalen Sprachen wie Englisch zu Chinesisch, Englisch zu Japanisch, Englisch zu Vietnamesisch oder umgekehrt.</template>
      <template slot="export">Exportieren</template>
      <template slot="export_description">Nach Abschluss der Untertitel- und Videobearbeitung können Sie in MP4 mit eingebetteten Untertiteln, SRT, VTT, PDF und TXT-Dateien exportieren.</template>
      <template slot="try_it_now">Jetzt ausprobieren</template>


      <template slot="editing_platform_desc1">Taptions Timeline-Funktion vereinfacht die Videobearbeitung. Wenn Bearbeitungen sich mit Untertiteln überschneiden, passt sie automatisch Text und Timing an und gewährleistet Genauigkeit und Synchronisation. Unser Online-Video-Editor ist perfekt für schnelle Bearbeitungen und erstellt mühelos professionelle Videos mit Untertiteln.</template>
      <template slot="video_time_stampped">
            <div class="video-wrapper" @click="onClicked('video1', true)">
                  <button v-show="!videoState.video1" class="play"></button>
                  <video id="video1" ref="video1" playsinline class="unique-video" poster="../assets/images/thumbnail/cut_thumbnail_en.webp" :src='"@/assets/video/Trim_Cut_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
            </div>
      </template>
      
      <template slot="editing_platform">Unglaubliche Bearbeitungsplattform.</template>
      <template slot="editing_platform_desc0">Zusätzlich zur Untertitel- und Transkriptbearbeitung ermöglicht unsere Untertitelgenerator-Plattform eine präzise Videobearbeitung direkt über die Untertitel. Sie passt automatisch das Timing anderer Untertitel an das bearbeitete Video an und gewährleistet eine reibungslose und synchronisierte Wiedergabe.</template>
      <template slot="video_trimmed">
            <div class="video-wrapper" @click="onClicked('video0', true)">
                  <div class="play-button" v-show="!videoState.video0">
                    <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
          <video id="video0" ref="video0" playsinline preload="none" class="intro-video" poster="../assets/images/thumbnail/trim_thumbnail_en_US.webp" :src='"@/assets/video/Trim_English.mp4"' frameborder="0" height="350" width="575" muted></video>
            </div>
      </template>

 
      <template slot="editing_platform_desc2">Unsere KI-Analysefunktion verbessert das Videoverständnis durch Erstellung von Videozusammenfassungen, Identifizierung von Schlüsselpunkten und Ermöglichung von Inhaltssuchen. Zusätzlich bietet sie häufig verwendete Vorlagen wie die Erstellung von YouTube-Kapiteln, Generierung von Videothemen und Korrektur von Untertiteln, was den Videobearbeitungsprozess verbessert.</template>
      <template slot="video_replace_all">
          <div class="video-wrapper" @click="onClicked('video2', true)">
              <div class="play-button" v-show="!videoState.video2">
                    <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video2" ref="video2" playsinline preload="none" poster="../assets/images/thumbnail/analysis_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/AI_Analysis_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template>
      <template slot="editing_platform_desc3">Mit Memos können Sie an bestimmten Zeitstempeln in Ihrem Videotranskript Notizen hinzufügen, die andere Benutzer einsehen können. Benutzer können schnell zu den entsprechenden Videoabschnitten navigieren, was den Video-zu-Text-Konvertierungsprozess verbessert. Dieses Tool ist nützlich für die Videobearbeitung, Untertitelerstellung und die Erstellung von YouTube-Kapiteln oder Zusammenfassungen.</template>
      <template slot="video_add_dictionary">
        <div class="video-wrapper" @click="onClicked('video3', true)">
              <div class="play-button" v-show="!videoState.video3">
                  <a class="popup-vimeo animated-circle" ><img :src='"../assets/images/play-button.webp"' alt="play-button" class="img-fluid" /></a>
                </div>
              <video id="video3" ref="video3" playsinline preload="none" poster="../assets/images/thumbnail/memo_thumbnail_en.webp" class="unique-video" :src='"@/assets/video/Memo_en.mp4"' frameborder="0" height="300"  width="575" muted></video>
          </div>
      </template> 

                   

      <template slot="low_cost">Günstige Preise.</template>
      <template slot="title_basic">Pay-as-you-go</template>
      <template slot="basic_cost_usd">$8 USD</template>
      <template slot="basic_cost_ntd">(240 NTD)</template>
      <template slot="hour">Stunde</template>
      <template slot="basic_feature5">Guthaben von <span style="color: #00d1b2;">60 Minuten</span></template>
      <template slot="basic_feature1">Automatisierte Transkription</template>
      <template slot="basic_feature2">Unterstützung für über 40 Sprachen</template>
      <template slot="basic_feature3">Hervorgehobener Texteditor</template>
      <template slot="basic_feature4">Übersetzung in über 50 Sprachen</template>
      <template slot="basic_feature7">Persönliches KI-Wörterbuch</template>
      <template slot="basic_feature6">Erlaubnis zur kommerziellen Nutzung</template>
      <template slot="basic_feature8">Unterstützt eingebrannte mehrsprachige Untertitel</template>

      <template slot="title_premium">Premium-Abonnement</template>
      <template slot="premium_cost_usd">$12 USD</template>
      <template slot="premium_cost_ntd">(360 NTD)</template>
      <template slot="premium_basic_cost_usd">$6 USD</template>
      <template slot="month">Monat</template>

      <template slot="premium_before"><span class="landing-arrow-left">&#10229;</span>Alle Funktionen aus「Pay-as-you-go」</template>
      <template slot="premium_feature1"><span style="color: #00d1b2;">120 Minuten</span> Guthaben auf Ihrem Konto jeden Monat.<br><span style="color:#797676;font-size:14px;font-weight: 100;">(Übertragbare Minuten, gültig bis zur Kündigung des Abonnements)</span></template>
      <template slot="premium_feature1_tooltip">Wenn die monatlichen Minuten nicht verbraucht werden, werden sie in den nächsten Monat übertragen und bleiben bis zur Kündigung des Abonnements gültig. <br>Diese monatlichen Minuten werden vor den zusätzlich gekauften Minuten verwendet. <br>Die zusätzlich gekauften Minuten verfallen nicht nach der Kündigung des Abonnements.</template>
      <template slot="premium_feature2">25% Rabatt auf stündliche Käufe</template>
      <template slot="premium_feature3">Unbegrenzte kostenlose Exporte von eingebrannten Untertiteln</template>
      <template slot="premium_feature4">Teilbares und bearbeitbares Transkript</template>
      <template slot="premium_feature5">Exportieren Sie Ihre Audioaufnahmen als Videos mit Untertiteln</template>
      <template slot="premium_feature6">Videoschnitt (Exportiertes Transkript/Untertitel werden automatisch angepasst)</template>

      <template slot="title_corp">Mengenabonnement</template>
      <template slot="bulk_cost_usd">$69 USD</template>
      <template slot="bulk_cost_ntd">(2070 NTD)</template>
      <template slot="bulk_basic_cost_usd">$4 USD</template>
      <template slot="bulk_before"><span class="landing-arrow-left">&#10229;</span>Alle Funktionen aus「Pay-as-you-go」und「Premium-Abonnement」</template>
       <template slot="bulk_feature2">63% Rabatt auf stündliche Käufe</template>
      <template slot="premium_feature1_bulk"><span style="color: #00d1b2;">1000 Minuten</span> Guthaben auf Ihrem Konto jeden Monat.<br><span style="color:#797676;font-size:14px;font-weight: 100;">(Übertragbare Minuten, gültig bis zur Kündigung des Abonnements)</span></template>
      <template slot="bulk_feature1">Bereitstellung von herunterladbaren Quittungen mit Ihrem Institutionsnamen und Steuer-ID</template>

       <template slot="bulk_feature3">Teilen Sie Minuten mit Benutzern</template>
       <template slot="bulk_feature4">6 verschiedene konfigurierbare Berechtigungen</template>

      <template slot="go_to_price">Weitere Details</template>
    </LandingPage>
</template>
<script>
import LandingPage from "./LandingPage";
//import Typed from 'typed.js';
export default {
  data: () => ({
      videoState:{
          video0:false,
          video1:false,
          video2:false,
          video3:false  
      }
  }),
  components: {
    LandingPage
  },
  methods: {
    onClicked(videoType, isPlay){
        const me = this;
        me.$refs[videoType].play();
        me.videoState[videoType] = isPlay;
    }
  },
  mounted(){
    const me = this;
    const video0 = document.getElementById("video0");  
    const video1 = document.getElementById("video1");   
    const video2 = document.getElementById("video2");   
    const video3 = document.getElementById("video3");   

    if(video0){
        video0.onended = function() {
            me.videoState.video0 = false;
        }
        // video0.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video0 = false;
        // } 
    }

    if(video1){
        video1.onended = function() {
            me.videoState.video1 = false;
        }
        // video1.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video1 = false;
        // } 
    }

    if(video2){
        video2.onended = function() {
            me.videoState.video2 = false;
        } 
        // video2.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video2 = false;
        // } 
    }


    if(video3){
        video3.onended = function() {
            me.videoState.video3 = false;
        } 
        // video3.onloadedmetadata = function() {
        //     this.currentTime = this.duration;
        //     me.videoState.video3 = false;
        // } 
    }
  }
}

</script>


           